export default __webpack_public_path__ + "static/media/960.1288ab44.jpg";